<ps-ui-loader></ps-ui-loader>
<ps-ui-tab-group
  [activeIndex]="activeTabIndex"
  (activeIndexChange)="setActiveTab($event)"
  psUiGtagEvent
  trackOn="click"
  action="survey_tab"
  category="Survey_Tab"
  [params]="{ event_label: 'Manage Survey Tab' }"
>
  <ps-ui-tab
    *ngFor="let tab of tabs; let i = index; trackBy: trackByProperty"
    [label]="tab.title"
    [className]="tab.className"
    [hasSpecialTheme]="tab.hasSpecialTheme || false"
  >
    <div
      class="menu-content"
      [ngClass]="{
        'pt-0':
          dynamicTabSurvey?.mc?.SVP &&
          dynamicTabSurvey?.id !== staticTabSurvey?.id
      }"
      id="traffic-channel-tab"
      *ngIf="activeTab.key === 'TRAFFIC_CHANNELS' && i === activeTabIndex"
    >
      <ng-template
        [ngTemplateOutlet]="selectedLocaleTabContentHeaderText"
      ></ng-template>
      <ng-container *ngIf="dynamicTabSurvey">
        <ps-ui-manage-traffic-channels
          [survey]="dynamicTabSurvey"
          [isCpiEditModeDisabled]="isCpiEditModeDisabled"
        ></ps-ui-manage-traffic-channels>
      </ng-container>
    </div>

    <div
      class="menu-content"
      [ngClass]="{
        'pt-0':
          dynamicTabSurvey?.mc?.SVP &&
          dynamicTabSurvey?.id !== staticTabSurvey?.id
      }"
      *ngIf="activeTab.key === 'AUDIENCE' && i === activeTabIndex"
    >
      <ng-template
        [ngTemplateOutlet]="selectedLocaleTabContentHeaderText"
      ></ng-template>
      <ng-container *ngIf="dynamicTabSurvey">
        <ps-ui-manage-audience
          [surveyId]="dynamicTabSurvey.id"
          [countryCode]="dynamicTabSurvey.countryCode"
        >
        </ps-ui-manage-audience>
      </ng-container>
    </div>
    <div
      class="menu-content"
      [ngClass]="{
        'pt-0':
          dynamicTabSurvey?.mc?.SVP &&
          dynamicTabSurvey?.id !== staticTabSurvey?.id
      }"
      *ngIf="activeTab.key === 'ACTIVITY_LOGS' && i === activeTabIndex"
    >
      <ng-template
        [ngTemplateOutlet]="selectedLocaleTabContentHeaderText"
      ></ng-template>
      <ng-container *ngIf="dynamicTabSurvey">
        <ps-ui-manage-activity-logs
          [surveyId]="dynamicTabSurvey.id"
          [notifications]="false"
        ></ps-ui-manage-activity-logs>
      </ng-container>
    </div>
    <div
      class="menu-content"
      [ngClass]="{
        'pt-0':
          dynamicTabSurvey?.mc?.SVP &&
          dynamicTabSurvey?.id !== staticTabSurvey?.id
      }"
      *ngIf="activeTab.key === 'QUOTAS' && i === activeTabIndex"
    >
      <ng-template
        [ngTemplateOutlet]="selectedLocaleTabContentHeaderText"
      ></ng-template>

      <ng-container *ngIf="dynamicTabSurvey">
        <ps-ui-manage-quotas
          class="tab-content-body"
          [survey]="dynamicTabSurvey"
          [surveyId]="dynamicTabSurvey.id"
        ></ps-ui-manage-quotas>
      </ng-container>
    </div>

    <div
      class="menu-content"
      [ngClass]="{
        'pt-0':
          staticTabSurvey?.mc?.SVP &&
          dynamicTabSurvey?.id !== staticTabSurvey?.id
      }"
      *ngIf="activeTab.key === 'LINK_OTHER_DETAILS' && i === activeTabIndex"
    >
      <ng-template
        [ngTemplateOutlet]="allLocalesTabContentHeaderText"
      ></ng-template>
      <ng-container *ngIf="staticTabSurvey">
        <ps-ui-manage-links
          [survey]="staticTabSurvey"
          [surveyId]="staticTabSurvey.id"
          [selectedSvpChildSurvey]="selectedSvpChildSurvey"
        ></ps-ui-manage-links>
      </ng-container>
    </div>

    <div
      class="menu-content reconcile-content"
      [ngClass]="{
        'pt-0':
          staticTabSurvey?.mc?.SVP &&
          dynamicTabSurvey?.id !== staticTabSurvey?.id
      }"
      *ngIf="activeTab.key === 'RECONCILE' && i === activeTabIndex"
    >
      <ng-template
        [ngTemplateOutlet]="allLocalesTabContentHeaderText"
      ></ng-template>
      <ng-container *ngIf="staticTabSurvey">
        <ps-ui-manage-reconcile
          [surveyId]="staticTabSurvey.id"
          [surveyStatus]="staticTabSurvey.status"
        ></ps-ui-manage-reconcile>
      </ng-container>
    </div>
    <div
      class="menu-content"
      [ngClass]="{
        'pt-0':
          staticTabSurvey?.mc?.SVP &&
          dynamicTabSurvey?.id !== staticTabSurvey?.id
      }"
      *ngIf="activeTab.key === 'REPORTS' && i === activeTabIndex"
    >
      <ng-template
        [ngTemplateOutlet]="allLocalesTabContentHeaderText"
      ></ng-template>
      <div class="container">
        <div class="row">
          <div *ngIf="staticTabSurvey" class="col">
            <ps-ui-manage-report
              [isServiceBuyer]="isServiceBuyerLoggedIn"
              [surveyId]="staticTabSurvey.id"
            ></ps-ui-manage-report>

            <div class="col" *ngIf="isServiceBuyerLoggedIn">
              <ps-ui-margin-report
                [surveyId]="staticTabSurvey.id"
              ></ps-ui-margin-report>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="menu-content supplier-tab"
      [ngClass]="{
        'pt-0':
          dynamicTabSurvey.mc?.SVP &&
          dynamicTabSurvey?.id !== staticTabSurvey?.id
      }"
      *ngIf="activeTab.key === 'SUPPLIERS' && i === activeTabIndex"
    >
      <ng-template
        [ngTemplateOutlet]="selectedLocaleTabContentHeaderText"
      ></ng-template>
      <ng-container *ngIf="dynamicTabSurvey">
        <ps-ui-manage-suppliers
          [surveyId]="dynamicTabSurvey.id"
          [survey]="dynamicTabSurvey"
        ></ps-ui-manage-suppliers>
      </ng-container>
    </div>
    <div
      class="menu-content"
      [ngClass]="{
        'pt-0':
          staticTabSurvey?.mc?.SVP &&
          dynamicTabSurvey?.id !== staticTabSurvey?.id
      }"
      *ngIf="activeTab.key === 'MULTI_COUNTRY' && i === activeTabIndex"
    >
      <ng-template
        [ngTemplateOutlet]="allLocalesTabContentHeaderText"
      ></ng-template>
      <ng-container *ngIf="staticTabSurvey">
        <ps-ui-manage-multi-country
          [mcUniqueId]="staticTabSurvey.mc_unique_id"
          [surveyId]="staticTabSurvey.id"
        ></ps-ui-manage-multi-country>
      </ng-container>
    </div>
    <div
      class="menu-content"
      [ngClass]="{
        'pt-0':
          dynamicTabSurvey?.mc?.SVP &&
          dynamicTabSurvey?.id !== staticTabSurvey?.id
      }"
      *ngIf="activeTab.key === 'MARGIN_MAX' && i === activeTabIndex"
    >
      <ng-template
        [ngTemplateOutlet]="selectedLocaleTabContentHeaderText"
      ></ng-template>
      <ng-container *ngIf="dynamicTabSurvey">
        <ps-ui-manage-margin-max-logs
          [surveyId]="dynamicTabSurvey.id"
        ></ps-ui-manage-margin-max-logs>
      </ng-container>
    </div>
    <div
      class="menu-content"
      [ngClass]="{
        'pt-0':
          dynamicTabSurvey?.mc?.SVP &&
          dynamicTabSurvey?.id !== staticTabSurvey?.id
      }"
      *ngIf="activeTab.key === 'HEALTH_CHECKS' && i === activeTabIndex"
    >
      <ng-template
        [ngTemplateOutlet]="selectedLocaleTabContentHeaderText"
      ></ng-template>
      <ng-container *ngIf="dynamicTabSurvey">
        <ps-ui-manage-health-checks [surveyId]="dynamicTabSurvey.id">
        </ps-ui-manage-health-checks>
      </ng-container>
    </div>

    <ng-template #selectedLocaleTabContentHeaderText>
      <ng-container *ngIf="dynamicTabSurvey">
        <div
          class="py-2 mb-4 text-center selected-locale-content-header-text"
          *ngIf="
            dynamicTabSurvey.mc?.SVP &&
            dynamicTabSurvey?.id !== staticTabSurvey?.id
          "
        >
          {{
            Constants.MC_QB.SELECTED_LOCALE_TEXT.replace(
              '#COUNTRY#',
              dynamicTabSurvey.countryName
            ).replace('#LANGUAGE#', dynamicTabSurvey.languageName)
          }}
        </div>
      </ng-container>
    </ng-template>

    <ng-template #allLocalesTabContentHeaderText>
      <div
        class="py-2 mb-4 text-center all-locales-content-header-text"
        *ngIf="
          staticTabSurvey?.mc?.SVP &&
          dynamicTabSurvey?.id !== staticTabSurvey?.id
        "
      >
        {{ Constants.MC_QB.ALL_LOCALE_TEXT }}
      </div>
    </ng-template>
  </ps-ui-tab>
</ps-ui-tab-group>
